const getModifiedDecays = (decayType) => {
    const matchParenthesesSpaces = /[()\s]/g;
    return decayType.replace(matchParenthesesSpaces, '');
};

export default getModifiedDecays;
